import { baseApi } from '../base';
import { TagType } from '../base/baseApi';
import { Channel } from './types';
import {
  transformToChannel,
  transformToChannels,
  transformToError,
} from './transformers';

export const youtubeChannelApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    addChannel: build.mutation<Channel, string>({
      query: (url) => {
        const formData = new FormData();
        formData.append('url', url);
        return {
          url: '/youtube/channels',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (_, error) => (error ? [] : [TagType.YOUTUBE_CHANNEL]),
      transformResponse: transformToChannel,
      transformErrorResponse: transformToError,
    }),
    getChannels: build.query<Channel[], void>({
      query: (params) => ({
        url: '/youtube/channels',
        method: 'GET',
        params,
      }),
      providesTags: [TagType.YOUTUBE_CHANNEL],
      transformResponse: transformToChannels,
    }),
  }),
});

export default youtubeChannelApi;
